import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/sharp-solid-svg-icons"
import { Box, Divider, styled, Typography } from "@mui/material"
import { extraColors } from "../../utils/theme"
import { LightTooltip } from "../LocationDetails/LocationRisk/Shared"

const Section = styled("div")(() => ({
  display: "grid",
  gap: 8,
  marginBottom: 16,
}))

const FiltersContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: 8,
  marginBottom: 16,
}))

export const ChartContainer = ({
  title,
  dataSourcePill,
  tooltipContent,
  children,
  slots: { filters },
}: {
  title: string
  dataSourcePill?: React.ReactNode
  tooltipContent: string | React.ReactNode
  children: React.ReactNode
  slots: {
    filters: React.ReactNode
  }
}) => {
  return (
    <Section>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexDirection: "row",
        }}
      >
        {tooltipContent && (
          <LightTooltip title={tooltipContent} arrow placement="top-end">
            <FontAwesomeIcon
              icon={faInfoCircle}
              style={{
                fontSize: 16,
                color: extraColors.status.navyLight,
              }}
            />
          </LightTooltip>
        )}
        <Typography variant="body1Bold">{title}</Typography>
        {dataSourcePill && <>{dataSourcePill}</>}
      </Box>
      <Divider color="white" />
      <FiltersContainer>{filters ? filters : null}</FiltersContainer>
      {children}
    </Section>
  )
}
